module.exports = __webpack_public_path__ + "assets/img/informationDate_second.c671a593.svg";